export interface IPatientFeedback {
  id?: string;
  journeyId?: string;
  patientFeedbackEntityIds?: any[];
  patientBabyFeedbackEntityIds?: any[];
  createdAt?: string;
  updatedAt?: string;
}

export interface IPatientFeedbackDTO {
  id?: string;
  patientCaseId?: string;  // Only needed for create/update operations
  journeyId?: string;
  patientFeedbackEntityIds?: any[];
  patientBabyFeedbackEntityIds?: any[];
}

export const defaultValue: Readonly<IPatientFeedback> = {};
